<app-hourglass *ngIf="!ready"></app-hourglass>
<div *ngIf="ready">
    <mat-tab-group>
        <mat-tab label="User Profile">
            <app-individuals #individualsComponent (saved)="onSaved()"
                             [groupsOwned]="getCurrentOwned()" [groups]="getCurrentGroups()" [individual]="getCurrentUser()"
                             [userProfile]="true"></app-individuals>
        </mat-tab>
        <mat-tab label="Authentication" *ngIf="isIndividual()">
            <app-api-key> </app-api-key>
        </mat-tab>
    </mat-tab-group>
</div>
<ng-container *ngIf="error">
    <div class="adError">
        <div>
            {{nameErrorText}}
            <mat-icon class="icon"></mat-icon>
        </div>
    </div>
</ng-container>
